<template>
  <div class="quiz-coin">
    <div class="tip"></div>
    <div class="content" @click="linkTo('Store')">
      <i></i>
      <span>{{ amount.quizRemainNum }}</span>
      <div class="more"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '@/store'

const router = useRouter()
const appStore = useAppStore()

const amount = computed(() => appStore.amount)

function linkTo(name) {
  router.push({
    name: name
  })
}
</script>

<style lang="scss" scoped>
.quiz-coin {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  .tip {
    position: absolute;
    top: get_vw(2);
    left: get_vw(-183);
    width: get_vw(176);
    height: get_vw(36);
    background-image: url(https://website.xdcdn.net/poster/58881/20250717/LYvnz0rW.png);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .content {
    position: relative;
    box-sizing: border-box;
    width: get_vw(177);
    height: get_vw(40);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(#000, 0.5);
    border: get_vw(2) solid rgba(#fff, 0.2);
    border-radius: get_vw(10);
    color: #fff;
    font-size: get_vw(20);

    i {
      @include icon_status('quiz_coin');
      width: get_vw(24);
      height: get_vw(26);
      margin-right: get_vw(10);
    }

    span {
      width: get_vw(106);
    }

    .more {
      width: get_vw(16);
      height: get_vw(16);
      right: get_vw(6);
      background: url(https://website.xdcdn.net/poster/58881/26match/icon/QYyrJqd0.png) center/contain no-repeat;
    }
  }
}
</style>
